import DuplicateOrderModule from "./DuplicateOrderModule";

export default DuplicateOrderModule;